import { Route, Routes } from 'react-router-dom';
import { Index } from './pages/Index';
import { observer } from 'mobx-react-lite';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import NewPassword from './components/auth/NewPassword';
import OidcCallback from './components/auth/OidcCallback';
import { useEffect } from 'react';
import PublicRoute from './PublicRoute';
import VerifyEmail from './components/auth/VerifyEmail';
import useEnhancedAuth from './_hooks/useEnhancedAuth';
import { useMainContext } from './hooks/useMainContext';
import LoadingScreen from './components/Globle/LoadingScreen';
import ProtectedRoute from './ProtectedRoute';
import { message } from 'antd';
import Viewer from './pages/Viewer';
export const App = observer(() => {
    const { isAuthenticated, isLoading } = useEnhancedAuth();
    const { viewManager, apiManager } = useMainContext();

    useEffect(() => {
        if (!isAuthenticated || isLoading) return;

        const fetchUser = async () => {
            try {
                const response = await apiManager.getUsersList();
                const result = await response.json();
                if (!response.ok)
                    throw new Error(
                        result.error || 'Failed to fetch users list',
                    );
                viewManager.setUsersList(result.users);
                viewManager.isSuperAdmin();
            } catch (error) {
                console.error('Error fetching users list:', error);
                message.error(error.message || 'Failed to fetch users list');
            }
        };
        fetchUser();
    }, [isAuthenticated, apiManager, viewManager, isLoading]);

    return (
        <>
            {(viewManager.isLoader || isLoading) && <LoadingScreen />}
            <Routes>
                {/* <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Index />
                        </ProtectedRoute>
                    }
                /> */}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Viewer />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/auth/login"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                {/* <Route
                    path="/auth/register"
                    element={
                        <PublicRoute>
                            <Register />
                        </PublicRoute>
                    }
                /> */}
                <Route
                    path="/auth/forgot-password"
                    element={
                        <PublicRoute>
                            <ForgotPassword />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/auth/verify-email"
                    element={
                        <PublicRoute>
                            <VerifyEmail />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/auth/reset-password"
                    element={
                        <PublicRoute>
                            <NewPassword />
                        </PublicRoute>
                    }
                />
                <Route path="/auth/callback" element={<OidcCallback />} />
            </Routes>
        </>
    );
});
